import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var MaskFace = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M320 64c-27.2 0-53.8 8-76.4 23.1l-37.1 24.8a96.2 96.2 0 0 1-53.3 16.1H56c-30.9 0-56 25.1-56 56v85c0 55.1 37.5 103.1 90.9 116.4l108 27C233.8 435 275.4 448 320 448s86.2-13 121.1-35.5l108-27C602.5 372.1 640 324.1 640 269v-85c0-30.9-25.1-56-56-56h-97.2c-19 0-37.5-5.6-53.3-16.1l-37.1-24.8C373.8 72 347.2 64 320 64zM132.3 346.3l-29.8-7.4c-32-8-54.5-36.8-54.5-69.9v-85c0-4.4 3.6-8 8-8h40v48c0 45.1 13.4 87.2 36.3 122.3zm405.1-7.4-29.8 7.4c23-35.2 36.3-77.2 36.3-122.3v-48h40c4.4 0 8 3.6 8 8v85c0 33-22.5 61.8-54.5 69.9zM192 208c0-8.8 7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16zm16 48h224c8.8 0 16 7.2 16 16s-7.2 16-16 16H208c-8.8 0-16-7.2-16-16s7.2-16 16-16zm16 80c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H240c-8.8 0-16-7.2-16-16z"
  }));
});
MaskFace.displayName = 'MaskFace';
export var MaskFaceDimensions = {
  height: 512,
  width: 640
};